<script lang="ts">
    import inView from "../../functions/observer"
    import { fly } from "svelte/transition"
    export let rows: Row[]
    function scrollToRow(name) {
        const element = document.getElementsByName(name)[0]
        if (element) {
            element.scrollIntoView({ behavior: "smooth" })
        }
    }
    let visible = false
    let node
</script>

{#key visible}
    <div
        class="siteRefs"
        bind:this="{node}"
        use:inView="{{ threshold: 0 }}"
        on:enter="{() => {
            visible = true
        }}"
    >
        {#each rows as row, i}
            {#if row.title && i != 0}
                <button
                    class="siteRef"
                    on:click="{() => scrollToRow(row.title)}"
                    in:fly="{{ duration: 1000, delay: 40 * i, opacity: 0, y: 150 }}"
                    ><img src="media/arrow-bottom-right.svg" alt="arrow" />{row?.title}</button
                >
            {/if}
        {/each}
    </div>
{/key}

<style lang="less">
    @import "../../assets/css/variables.less";
    .siteRefs {
        margin-top: 25px;
        button {
            display: flex;
            align-items: center;
            img {
                transform: scale(1.4);
                margin: 0.5rem 0.9rem 0.5rem 0rem;
            }
            color: @link-font-color;
            font-weight: 600;
        }
    }
</style>
